// extracted by css-extract-rspack-plugin
module.exports =  {"textarea":"Textarea__textarea--oq7IX","disabled":"Textarea__disabled--xazSI","invalid":"Textarea__invalid--gtPRv"};